// Mock data for Sharada Rama Rao Trust website

export const trustInfo = {
  name: "Sharada Rama Rao Trust",
  tagline: "Join Hands . Spread Kindness",
  subtitle: "A legacy of Selfless Service",
  registrationNo: "243/15-16",
};

export const aboutParents = {
  title: "About our Parents",
  body: `Our father, Sri P. Rama Rao S/o late Padmanabhya was born in the year 1914. Our mother, Smt. Sharada Rama Rao D/o Late Venkat Rao, was born in the year 1927. They were married in the year 1942.

Our parents lived in a small dwelling in the heart of Mangaluru City, near Laxmi Bagh temple in Shedigudde. Their mediocre income never deterred them from helping people who came to Mangalore for education, medical or job-related problems. Our parents always welcomed them warmly offering boarding and lodging facilities in our little house from time to time. Since our house was close to the bus stop, railway station, schools, colleges and hospitals, there was no dearth of visitors throughout the year. As children we were thus brought up in an environment of kindness, generosity and selfless service which made us believe that every good deed leaves a mark in the world. – A mark of kindness.`,
  fatherName: "Sri P. Rama Rao",
  motherName: "Smt. Sharada Rama Rao",
};

export const services = [
  "Scholarship Distribution",
  "Visit and Support to Vriddashrama (Old Age Home)",
  "Honouring Senior Citizens",
  "Donation of Chairs and Tables to Panambur Nandaneshawara Temple",
  "Vana Mahotsava (Tree Plantation Drive)",
  "Support and Activities at Shishu Nilaya",
  "Organized and sponsored Eye Camps",
  "Donated Water Purifiers to Temple",
  "Medical Aid Distribution",
];

export const servicesQuote = "CHARITY BEGINS AT HOME\nBUT SHOULD NOT END THERE";

export const getInvolved = [
  {
    title: "Donate",
    description: "No matter the amount, your donation will make a big difference in the lives of our beneficiaries.",
    cta: "Donate",
    shape: "bowl",
  },
  {
    title: "Volunteer",
    description: "Join us in our community activities and events",
    cta: "Sign up",
    shape: "person",
  },
  {
    title: "Spread the word",
    description: "Help us spread our advocacy to your friends, family, and colleagues.",
    cta: "Share page",
    shape: "paper",
  },
];

export const taxNote = [
  "The trust is registered under Sec 12 A of the Income Tax Act 1961",
  "Donations to the Trust is exempted under Sec 80G (5)(6) of the Income Tax Act 1961",
];

export const trustees = [
  { name: "P Ravindra Rao", role: "Retired Senior Manager, Karnataka Bank", initials: "PR", img: "/trustee-ravindra.jpg" },
  { name: "P Shobha Rao", role: "Retired Chief Manager, Karnataka Bank", initials: "PS", img: "/trustee-shoba.jpg" },
  { name: "Vasanthi Rao", role: "Retired Lecturer & Author", initials: "VR", img: "/trustee-vasanthi.jpg" },
  { name: "Jayanthi Rao", role: "Retired Professor & HOD of Maths, Jyothi Nivas College", initials: "JR", img: "/trustee-jayanthi.jpg" },
  { name: "Surendra Rao", role: "Retired Manager, Karnataka Bank", initials: "SR", img: "/trustee-surendra.jpg" },
];

export const notableActivities = [
  {
    id: 1,
    title: "Kaithota Kranti — Kitchen Gardening Training",
    paper: "Local Daily · 26 September 2022",
    summary: "Trust President P. Ravindra Rao inaugurated the Kaithota Kranti kitchen-gardening training programme at Barebail, organised in association with the Savayava Krushika Grahaka Balaga. Trustees P. Shobha Rao and P. Surendra Rao were present. Speakers explained how home kitchen-waste composting can grow poison-free vegetables and reduce medical expenses.",
    img: "/news-1.jpg",
  },
  {
    id: 2,
    title: "Water Purifier Donation — Lakhmi Narayani Temple",
    paper: "English Daily · Mangaluru",
    summary: "Sharada Rama Rao Trust treasurer P. Surendra Rao donated a water purifier unit to Lakhmi Narayani Temple trustee K. Krishna Shet on the temple premises in Mangaluru. Donors P. Balakrishna Rao, Vasanthi Rao and Trust chairman P. Ravindra Rao look on.",
    img: "/news-2.jpg",
  },
  {
    id: 3,
    title: "Financial Aid to Lockdown-Affected Families",
    paper: "Diganta · Mangaluru",
    summary: "During the Covid-19 lockdown, Trust chairman P. Ravindra Rao celebrated his birthday by extending financial support to 30 lockdown-affected workers and daily-wage earners — distributing ₹65,000 in aid. Trustees P. Shobha Rao, P. Usha Rao and P. Surendra Rao were present.",
    img: "/news-3.jpg",
  },
  {
    id: 4,
    title: "10th Anniversary Celebrations of the Trust",
    paper: "Kannada Daily · Mangaluru",
    summary: "Sharada Rama Rao Charitable Trust celebrated its 10th anniversary with a felicitation programme at the Trust office. Vijaya Rao, American Director of Anwesha Bharati Hundi Company, presided as chief guest. 15 beneficiaries were honoured for their academic and skill achievements. Trustees P. Surendra Rao, P. Shobha Rao, P. Usha Rao and P. Karthik were present.",
    img: "/news-4.jpg",
  },
  {
    id: 5,
    title: "Support to Shaktinagara Ganesha Govu Nilaya (Cow Shelter)",
    paper: "Kannada Daily · Mangaluru",
    summary: "Sharada Rama Rao Charitable Trust extended a helping hand to the Ganesha Cow Shelter in Shaktinagara. Trustees visited the shelter and provided cattle equipment, feed and provisions worth 6 months. The shelter houses around 20 indigenous cows tended by Ganesha, an auto-rickshaw driver by profession, who dedicates his entire earnings to the cattle. Trust President P. Ravindra Rao, treasurer Surendra Rao and trustees P. Vasanthi Rao, Shobha Rao, Usha Rao, P.B. Rao and Karthik Rao were present.",
    img: "/news-5.jpg",
  },
  {
    id: 6,
    title: "\"A Rich Heart is Needed to Serve Society\" — 12th Anniversary Felicitation",
    paper: "Mahanagara · Kannada Daily",
    summary: "At the Trust's book-distribution, talent-award and felicitation programme, chief guest Ramananda Pangal (President, Mannagudde Gujjaria Sabha) said one needs a rich heart and honesty to serve society. Speaking of the Trust's 12 years of continuous service — from school book distribution and scholarships to health-support and old-age care — he praised the family for institutionalising service. Chairman P. Ravindra Rao and trustees felicitated achievers, including a Class 10 topper (90 %) from Kulshekar's Saint Joseph School and social workers from Shaktinagar.",
    img: "/news-6.jpg",
  },
];

export const contactInfo = {
  mobile: "+91 81470 22006",
  email: "sharadaramaraotrust2014@gmail.com",
  address: '4-4/4, "Laxmi Kripa", Barebail, Kadri, Mangalore, Karnataka - 575004',
};
